import { render, staticRenderFns } from "./PageDetails.vue?vue&type=template&id=089af6ac"
import script from "./PageDetails.vue?vue&type=script&lang=ts"
export * from "./PageDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports